export enum AdminAppEvents {
    ForceSignIn = 'AdminApp.ForceSignIn',
}